export const UPDATE_LOCALE = 'UPDATE_LOCALE';

export function updateLocale(locale) {
  return {
    type: UPDATE_LOCALE,
    locale
  };
}



// WEBPACK FOOTER //
// ./src/actions/preferences.js